import { createContext } from "react";
import type { Dispatch, SetStateAction } from "react";

interface AuthProps {
  user: {
    given_name: string,
    email: string,
    sub: string,
    roles: string[]
    token?: string
  } | null;
  signin: (newUser: AuthProps["user"], callback: () => void) => void;
  signout: (callback: () => void) => void;
  isIdle: boolean
  darkMode: boolean
  setDarkMode: Dispatch<SetStateAction<boolean>>
  setIsIdle: Dispatch<SetStateAction<boolean>>
  expiredTokenError: boolean,
  setExpiredTokenError: Dispatch<SetStateAction<boolean>>
  unknownUserError: boolean,
  setUnknownUserError: Dispatch<SetStateAction<boolean>>
}

const AuthContext = createContext<AuthProps | null>(null);

const authProvider = {
  isAuthenticated: false,
  signin(callback: () => void) {
    authProvider.isAuthenticated = true;
    callback();
  },
  signout(callback: () => void) {
    authProvider.isAuthenticated = false;
    callback();
  }
};

export { AuthContext, authProvider }; export type { AuthProps };
